import { render, staticRenderFns } from "./StoreSeckillBody.vue?vue&type=template&id=67fee467&scoped=true&"
import script from "./StoreSeckillBody.vue?vue&type=script&lang=js&"
export * from "./StoreSeckillBody.vue?vue&type=script&lang=js&"
import style0 from "./StoreSeckillBody.vue?vue&type=style&index=0&id=67fee467&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fee467",
  null
  
)

export default component.exports